import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f4a79ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "principally footer_box" }
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "copyright" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "principally" }, [
    /*#__PURE__*/_createElementVNode("span", null, "版权所有：xxxxxxxxxxxxxxxxxxx")
  ])
], -1))

import logo from "@/static/logo.png";
import { ref } from "vue";
import contactUs from "@/views/Home/page/contactUs.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'eFooter',
  setup(__props) {

const menuList = ref();

menuList.value = [
  {
    // 计算机视觉与核心算法
    title: "核心技术",
    content: [
      // {
      //   titile: "核心算法",
      //   path: "/coreTechnology/deepLearning",
      // },
      {
        titile: "气象AI数据服务平台",
        path: "/coreTechnology/weatherAI",
      },
    ],
  },
  {
    title: "产品服务",
    content: [
      // {
      //   titile: "气象可视化",
      //   path: "/productService/weatherVisual",
      // },
      {
        titile: "气象预报预警平台",
        path: "/productService/integrationPlatform",
      },
      {
        titile: "气象数据产品",
        path: "/dataProduct/0/00",
      },
      {
        titile: "水电站监管平台",
        path: "/productService/waterConservancy",
      },
      {
        titile: "AIoT只能观测台",
        path: "/productService/AIoT",
      },
      {
        titile: "MC机器人",
        path: "/productService/robot",
      },
      {
        titile: "HISTORY气象台",
        path: "/productService/history",
      },

      {
        titile: "更多",
        path: "/productService/integrationPlatform",
      },
    ],
  },
  {
    title: "解决方案",
    content: [
      {
        titile: "农业气象服务",
        path: "/solution/geoponics",
      },
      {
        titile: "保险气象服务",
        path: "/solution/insurance",
      },
      {
        titile: "旅游气象服务",
        path: "/solution/tour",
      },
      {
        titile: "航空气象服务",
        path: "/solution/aviation",
      },
      {
        titile: "交通气象服务",
        path: "/solution/traffic",
      },
      {
        titile: "更多",
        path: "/solution/geoponics",
      },
    ],
  },

  {
    title: "生态合作",
    content: [
      {
        titile: "合作伙伴",
        path: "/zoology/cooperation",
      },
      // {
      //   titile: "生态合伙人",
      //   path: "/zoology/partner",
      // },
    ],
  },
  {
    title: "关于我们",
    content: [
      {
        titile: "公司介绍",
        path: "/about/company",
      },
      // {
      //   titile: "新闻资讯",
      //   path: "/about/news",
      // },
      // {
      //   titile: "联系我们",
      //   path: "/about/contactUs",
      // },
      {
        titile: "招贤纳士",
        path: "/about/recruit",
      },
    ],
  },
];

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(contactUs),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            src: _unref(logo),
            alt: ""
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, [
                _createElementVNode("h4", null, _toDisplayString(item.title), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.content, (item1, index) => {
                  return (_openBlock(), _createElementBlock("p", { key: index }, [
                    _createVNode(_component_router_link, {
                      to: item1.path
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(item1.titile), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                }), 128))
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _hoisted_6
  ], 64))
}
}

})